module.exports = __webpack_public_path__ + "static/neuehassunica-regular-ffd28f65d63c8b49df527fcf0aa7d3ca.woff2";